import React, { Component } from 'react'

import { Formik, Form } from 'formik'
import { connect } from 'react-redux'
import { Notification } from 'react-notification'

import useTranslation from 'next-translate/useTranslation'
import { getPriceTypes } from 'SRC/modules/users/Profile/selectors'

import { getCurrentSubCategory, getSpecifications } from 'SRC/modules/categories/selectors'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import { getUserInfo } from 'SRC/modules/users/Profile/selectors'

import {
  BrandProductServices,
  Photos,
  EquipmentNew,
  TitleNew,
  Condition,
  Compatibility,
  Geo,
  SpecificationsNew,
  PriceSwappDescription
} from 'SRC/modules/ads/shared/components/FormElements'

import { getValidationSchema } from 'SRC/modules/ads/shared/functions'

import { setError } from 'SRC/modules/ads/add/actions'
import { getError, getWasSentSms, getActiveTab } from 'SRC/modules/ads/add/selectors'

import { getInitialValues } from './functions'

import { PromoPeriods } from '../PromoPeriodsNew'
import { AuthAndRegistrationForm } from '../AuthAndRegisterForm'
import { SmsCode } from '../SmsCode'

const DetailForm = ({
  currentSubCategory,
  specifications,
  isAuthorized,
  userInfo,
  hasPriceFromToAddon,
  hasPriceOnRequestAddon,
  hasSeperateRangeAddon,
  hasPriceFromAddon,
  hasAdTitleAddon,
  priceTypes,
  onSubmit,
  formError,
  wasSentSms,
  activeTab,
  setError
}) => {
  const { t } = useTranslation('common')
  const [compUniversalSelected, setCompUniversalSelected] = React.useState(false)

  const isActiveRegistrationTab = activeTab === 'register'

  return (
    <Formik
      initialValues={
        getInitialValues({
          currentSubCategory,
          isAuthorized,
          userInfo,
          specifications,
          hasPriceFromToAddon,
          hasPriceOnRequestAddon,
          hasAdTitleAddon,
          priceTypes,
          t: item => t(item)
        })
      }
      validationSchema={getValidationSchema({
        category: currentSubCategory,
        categorySpecifications: specifications,
        formType: 'addDetail',
        isAuthorized,
        compUniversalSelected,
        activeTab,
        t: (item => t(item))
      })}
      validateOnBlur={false}
      // validateOnChange={false}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {formikProps => {
        return (
          <Form className='dodavanje-oglasa-form-podaci'>
            <Photos />

            <div className='ads-add__pre-specifications'>
              {/* Brand, Products, Services, Service Types */}
              <BrandProductServices />

              {/* Specifications */}
							<SpecificationsNew key='specs_1' formType='addDetail' showOnlySpecs={[t('oznaka_spec')]}  />
              
              {/* Condition */}
              {currentSubCategory && currentSubCategory.condition ? <Condition /> : null}
            </div>

            <TitleNew
              hasAdTitleAddon={hasAdTitleAddon}
              placeholder={currentSubCategory && currentSubCategory.fillerText ? currentSubCategory.fillerText : ''}
            />

            <div className='ads-add__post-specifications'>
              {/* Specifications */}
							<SpecificationsNew key='specs_2' formType='addDetail' hideSpecs={[t('oznaka_spec')]} />
            </div>

            {/* Equipment */}
            <div className='ads-add__equipment'>
              <EquipmentNew />
            </div>

            {/* Compatibility */}
            {currentSubCategory && currentSubCategory.compatibilityCategories && currentSubCategory.compatibilityCategories.length
              ? (
                <Compatibility onUniversal={isSelected => {
                  setCompUniversalSelected(isSelected)
                  setTimeout(() => formikProps.setFieldValue('compatibilityUniversality', isSelected), 1)
                }}
                />
              ) : null
            }

            {/* Geo */}
            <Geo />

            {/* Price, Description, Swapps */}
            <PriceSwappDescription
              hasPriceFromAddon={hasPriceFromAddon}
              hasSeperateRangeAddon={hasSeperateRangeAddon}
              hasPriceFromToAddon={hasPriceFromToAddon}
              hasPriceOnRequestAddon={hasPriceOnRequestAddon}
            />

            <PromoPeriods />

            {!isAuthorized ? <AuthAndRegistrationForm /> : null}
            {!isAuthorized && wasSentSms && isActiveRegistrationTab ? <SmsCode /> : null}

            {!wasSentSms || (wasSentSms && !isActiveRegistrationTab)
              ? (
                <button
                  key='submit'
                  className='btn-oglas-submit ads-add__submit' type='submit'
                  disabled={!formikProps.dirty || formikProps.isSubmitting}
                  onClick={e => {
                    e.preventDefault()

                    if (!formikProps.isValid) {
											console.log('fp not valid', formikProps)
                      // setError('Podaci nisu pravilno popunjeni. Polja sa * su obavezna.')
                      setError(t('addAdRequiredFieldError'))
                    }

                    formikProps.handleSubmit()
                  }}
                >
                  {t('Pošalji oglas')}
                </button>
              ) : null
            }

            <Notification
              isActive={Boolean(formError)}
              message={formError || ``}
              action={'Sakrij'}
              onClick={() => setError('')}
            />
          </Form>
        )
      }}
    </Formik>
  )
}

const mapStateToProps = state => {
	const currentSubCategory = getCurrentSubCategory(state)

	return {
		currentSubCategory,
		specifications: getSpecifications(state),
		isAuthorized: getIsAuthorized(state),
		userInfo: getUserInfo(state),
    formError: getError(state),
    wasSentSms: getWasSentSms(state),
    activeTab: getActiveTab(state),
    priceTypes: getPriceTypes(state)
	}
}


export default connect(mapStateToProps, { setError })(DetailForm)
